import React, { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash.debounce';
import UITimePicker from '../ui-controls/time-field';
import moment from "moment";

const TimeFilter = ({ filterValue, filterDelay, onChange, render, readOnly, style }) => {
  const [value, setValue] = useState(filterValue ? filterValue.value : '');

  const debouncedOnValueChange = useCallback(
    debounce((value) => {
      onChange(Object.assign({}, filterValue, { value }));
    }, filterDelay >= 1 ? filterDelay : 0, {
      leading: false,
      trailing: true
    }),
    [filterDelay, onChange, filterValue]
  );

  useEffect(() => {
    return () => {
      debouncedOnValueChange.cancel();
    };
  }, [debouncedOnValueChange]);

  const handleChange = (time) => {
    // Create a new Moment object with the default date and original time
    let formattedTime = ""
    let newTime = null
    if(time?.target?.value) {
        newTime = moment(time?.target?.value, ["HH:mm", "hh:mm A"])
          // .year(1970)
          // .month(0) // January
          // .date(1);
      
        // Format the new time as a string
       formattedTime = newTime.format("YYYY-MM-DD hh:mm A");
    }
  
    // Call debouncedOnValueChange and setValue with the formatted string
    debouncedOnValueChange(formattedTime);
    setValue(newTime);
  };

  const inputProps = {
    readOnly,
    style: Object.assign({}, { minWidth: 0 }, style),
    value: filterValue ? value : null,
    onChange: handleChange,
    size: "small",
    showClear: true,
    sx:{
        width: "100%",
        background: 'white', 
        borderColor: 'transparent',
        height: "32px",
        ".MuiInputBase-root": {
            height: "32px",
            fontSize: "14px"
        },
    },
    iconSx: {
        width: "18px",
        height: "18px",
        color: "var(--base-100)"
    },
    format:"hh:mm A",
    placeholder: "Select Time",
    className: "inovua-react-datagrid__column-header__filter inovua-react-datagrid__column-header__filter--string",
    type: "time"
  };

  return render(<UITimePicker {...inputProps} />);
};

export default TimeFilter;
